import React from "react";
import Image from "../../assets/img/Why-img.jpeg"

const Why = () => {
  return (
    <section className="section">
      <div id="about" className="container mx-auto">
        <div className="flex flex-col items-center lg:flex-row gap-x-8">
          {/* image */}
          <div
            className="order-2 lg:order-1"
            data-aos="fade-right"
            data-aos-offset="400"
            data-aos-duration='600'
          >
            <img src={Image} alt="AEC" />
          </div>
          {/* text */}
          <div
            className="order-1 lg:order-2 max-w-[480px]"
            data-aos="fade-left"
            data-aos-offset="450"
            data-aos-duration='600'
          >
            <h2 className="section-title">Why you should choose us</h2>
            <p className="section-subtitle">
            At our company, we are committed to providing high-quality, sustainable solutions for our clients. Our team of experts has years of experience in the industry and will work with you every step of the way to ensure a successful project. We pride ourselves on our attention to detail and our commitment to customer satisfaction.
            </p>
            <button className="btn px-6">Learn more</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why;
